import {Doctor} from "./Doctor";

export const AddDoctorFormTemplate = Object.freeze({
    sections: [
        {
            size: 7 / 12,
            compact: true,
            inputs: [
                Doctor.name,
                Doctor.speciality,
                Doctor.email,
                Doctor.telephone_number,
                Doctor.nif
            ],
        },
        {
            title: "Detalles",
            size: 1/2,
            compact: true,
            inputs: [
                Doctor.direction,
                Doctor.direction_facturation,
                Doctor.formation,
                Doctor.description,
            ],
        },
    ]
});

export const ConfirmDoctorFormTemplate = Object.freeze({
    sections: [
        {
            size: 1 / 2,
            compact: true,
            inputs: [
                Doctor.name,
                Doctor.speciality,
                Doctor.telephone_number,
                Doctor.nif,
                Doctor.direction,
                Doctor.direction_facturation,
                Doctor.formation,
                Doctor.description,
                Doctor.password,
                Doctor.passwordVerification
            ],
        },
    ]
});